/**
 * Performs inexpensive rounding, without any type conversion.
 */
export const round = (value: number, precision: number) => {
  const BASE = 10;
  const pow = Math.pow(BASE, precision);
  return Math.round(value * pow) / pow;
};
